/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Moves a reply from the waitlist to a place in the time.
 * @export
 * @interface WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto
 */
export interface WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto {
    /**
     * The reply to move up.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto
     */
    replyId?: number;
    /**
     * The time the reply is waiting for.
     * @type {number}
     * @memberof WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto
     */
    timeId?: number;
}

/**
 * Check if a given object implements the WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto interface.
 */
export function instanceOfWebApiServicesDataTransferObjectsReplyServicePromoteReplyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoFromJSON(json: any): WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto {
    return WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoFromJSONTyped(json, false);
}

export function WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'replyId': !exists(json, 'replyId') ? undefined : json['replyId'],
        'timeId': !exists(json, 'timeId') ? undefined : json['timeId'],
    };
}

export function WebApiServicesDataTransferObjectsReplyServicePromoteReplyDtoToJSON(value?: WebApiServicesDataTransferObjectsReplyServicePromoteReplyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'replyId': value.replyId,
        'timeId': value.timeId,
    };
}

